import React from 'react';

export const AssistantCommandContext = React.createContext({ current: null });
